import store from '@/store';

export default class NewInternalCallEvent {
  constructor(body) {
    console.log('[COLLEAGUES] - Chamando colega', body);

    const status = !Object.hasOwn(body.internalCall, 'status')
      ? 'calling'
      : body.internalCall.status;

    const params = {
      from: body.internalCall.from,
      to: body.internalCall.to,
      status,
    };

    store.dispatch('colleagues/setInternalCall', params);
    store.dispatch('channel/updateStatusVoice', 'in_attendance');
  }
}
